import '@quickmd-llc/design-system/patchQuillClipboard'
import { PersistGate } from 'redux-persist/integration/react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PageLoadingSpinner } from 'ui_kit_qmd'
import { persistor, store } from './app/store'
import './index.css'
import App from './App'
import { initSentry } from './utils/sentryUtility'
import { ReactQueryProvider } from './api/components/ReactQueryProvider'
import { initOrvalTokenModules } from './api/initOrvalTokenModules'

// we want to call this as early as possible so that whenever orval is used, the module setters exist/have been set, and
// the token getters will actually work
initOrvalTokenModules()

const container = document.getElementById('root')

initSentry()

if (!container) {
  throw new Error('Root element not found')
}
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <ReactQueryProvider>
      <PersistGate loading={<PageLoadingSpinner />} persistor={persistor}>
        <App />
      </PersistGate>
    </ReactQueryProvider>
  </Provider>,
)
